import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useActiveSessionLastUsedModel, useActiveSessionSelectedModel } from "@ext/agent/components/store/AgentStore";
import t from "@ext/localization/locale/translate";

export const ChatDisclaimer = () => {
	const { enabled, url } = PageDataContextService.value.conf.enterpriseCloud;
	const selectedModel = useActiveSessionSelectedModel();
	const lastUsedModel = useActiveSessionLastUsedModel();
	if (!enabled || !url) return null;
	const showModelSwitchWarning =
		!!lastUsedModel &&
		!!selectedModel &&
		(selectedModel.type !== lastUsedModel.type || selectedModel.name !== lastUsedModel.name);

	return (
		<p className="mt-auto shrink-0 px-1 pb-2 pt-3 text-center text-[10px] leading-none text-muted-foreground">
			{t(showModelSwitchWarning ? "agent.input.model-switch-cost-warning" : "agent.input.ai-disclaimer")}
		</p>
	);
};
